// extracted by mini-css-extract-plugin
export default {"actions":"PushToTvPopup_actions__KAUsd","separator":"PushToTvPopup_separator__6vEWK"};